import { VpLoader } from '@vtmn-play/react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'
import { FiltersBar } from '@/components/FiltersBar/FiltersBar'
import { NoResults } from '@/components/ProductsGallery/NoResults'
import { ProductsViewHeader } from '@/components/ProductsHeader/ProductsViewHeader'
import { ProductsProvider } from '@/contexts/products/ProductsProvider'
import { useProductsContext } from '@/contexts/products/useProductsContext'
import { isGallerySM } from '@/types/catalog'
import { ProductsListLoader } from './ProductsListLoader'
import { ProductsListRow } from './ProductsListRow'
import './products-list.scss'

function ProductsListContent() {
  const { t } = useTranslation()
  const { season = '' } = useParams<{ season: string }>()

  const { customViewSelections, isFiltersOpen, products, sentinelRef, isLoading, isFetchingNextPage, isRefreshing } = useProductsContext()

  const isEmpty = !products?.length && !isLoading

  return (
    <div className="products-list" data-testid="products-list">
      <ProductsViewHeader />
      <div className="products-list__wrapper">
        {isFiltersOpen && <FiltersBar />}
        <div className="products-list__content" aria-busy={isRefreshing}>
          <section>
            <h2 className="sr-only">
              {t('products-page.products-list.results')}
            </h2>
            {isLoading && !products?.length && <ProductsListLoader />}
            {isEmpty
              ? <NoResults />
              : (
                  <ul className="products-list__rows" data-testid="products-list-rows">
                    {products?.filter(isGallerySM).map(product => (
                      <li key={product.super_model.id}>
                        <ProductsListRow product={product} season={season} customView={customViewSelections} />
                      </li>
                    ))}
                    {isFetchingNextPage && <ProductsListLoader />}
                  </ul>
                )}
            {isRefreshing && products.length > 0 && (
              <div className="products-list__refresh" role="status" aria-label={t('aria-label.refreshing-products')}>
                <VpLoader size="small" />
              </div>
            )}
            <div ref={sentinelRef} />
          </section>
        </div>
      </div>
    </div>
  )
}

export function ProductsList() {
  return (
    <ProductsProvider target="list">
      <ProductsListContent />
    </ProductsProvider>
  )
}
